import React, { useContext } from "react";
import { AssignGroupContext } from "./context";
import { Tooltip } from "@mui/material";
import { OwcIconButton } from "@one/react";
import { ACTIONS_ROW_STYLE } from "../../components/tableMetaHelpers";

const Actions = ({ item }) => {
  const { setDialogOpen, setIsEditMode, setLastEditGroup, setDialogDeleteOpen, setIsDeleteMode } = useContext(AssignGroupContext);
  
  return (
    <div style={ACTIONS_ROW_STYLE}>
      <Tooltip
        data-testid={"equipment-edit-button-tooltip" + item.groupName}
        title={"Edit group assign"}
        placement="left"
        arrow
      >
        <OwcIconButton
          key={`booking-admin-table-edit-instrument-button-${item.groupName}`}
          data-testid={`booking-admin-table-edit-instrument-button-${item.groupName}`}
          onClick={() => {
            setIsEditMode(true);
            setLastEditGroup(item);
            setDialogOpen(true);
          }}
          icon="edit"
          type="legacy"
          flat
        />
      </Tooltip>
      <Tooltip data-testid={"equipment-edit-button-tooltip" + item.id} title={"Delete"} placement="left" arrow>
        <OwcIconButton
          key={`booking-admin-table-edit-instrument-button-${item.id}`}
          data-testid={`booking-admin-table-edit-instrument-button-${item.id}`}
          onClick={() => {
            setIsEditMode(false);
            setDialogDeleteOpen(true);
            setLastEditGroup(item);
            setIsDeleteMode(true);
          }}
          icon="delete"
          type="legacy"
          flat
        />
      </Tooltip>
    </div>
  );
};
export default Actions;
